// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"43d87d84","396":"ad76bb11","453":"258b012d","483":"361602ce","626":"9bec24c5","634":"497c05e0","724":"fe3bb0d1","736":"3de4430f","984":"444bd657"}[chunkId] + ".chunk.js";
};